import React from 'react';
import PropTypes from 'prop-types';

import './Logo.css';

const classNames = ({
  className, spin, white, small, medium, big,
}) => {
  const names = ['Logo'];
  if (className) {
    names.push(className);
  }
  if (spin) {
    names.push('spin');
  }
  if (white) {
    names.push('white');
  }
  if (small) {
    names.push('small');
  }
  if (medium) {
    names.push('medium');
  }
  if (big) {
    names.push('big');
  }
  return names.join(' ');
};

const Logo = ({
  className,
  spin,
  white,
  small,
  medium,
  big,
}) => (
  <div
    className={classNames({
      className,
      spin,
      white,
      small,
      medium,
      big,
    })}
  >
    <svg
      version="1.1"
      id="Layer_2"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="100%"
      height="100%"
      viewBox="992.126 1106.93 850.394 620.787"
      enableBackground="new 992.126 1106.93 850.394 620.787"
      xmlSpace="preserve"
    >
      <g>
        <polygon className="brick-1" points="1235.153,1363.405 1074.04,1524.517 1074.04,1363.405" />
        <polygon className="brick-2" points="1246.66,1363.405 1407.771,1524.517 1407.771,1363.405" />
        <polygon className="brick-3" points="1580.392,1363.405 1419.28,1524.517 1419.28,1363.405 " />
        <polygon className="brick-4" points="1591.899,1363.405 1753.011,1524.517 1753.011,1363.405" />
        <polygon className="brick-5" points="1235.152,1190.785 1074.04,1351.896 1235.153,1351.896" />
        <polygon className="brick-6" points="1580.392,1190.785 1419.28,1351.896 1580.392,1351.896" />
        <polygon className="brick-7" points="1246.661,1190.785 1407.773,1351.896 1246.661,1351.896" />
        <polygon className="brick-8" points="1591.899,1190.785 1753.011,1351.896 1591.899,1351.896" />
      </g>
    </svg>
  </div>
);

Logo.propTypes = {
  className: PropTypes.string,
  spin: PropTypes.bool,
  small: PropTypes.bool,
  medium: PropTypes.bool,
  big: PropTypes.bool,
  white: PropTypes.bool,
};

Logo.defaultProps = {
  className: '',
  spin: false,
  small: false,
  medium: false,
  big: false,
  white: false,
};

export default Logo;



// WEBPACK FOOTER //
// ./src/components/Logo.jsx